<script>
  import FeedbackForm from '@components/feedbacks/form.svelte'
  import { MessageCircle } from 'lucide-svelte'
  import { cn } from '@lib/utils'
  import { page } from '@inertiajs/svelte'

  let { record, feedback } = $props()

  let user = $derived($page.props.user)
  let open = $state(false)
  let hasExisting = $derived(!!feedback?.id)
</script>

{#if user?.has_active_membership}
  <button
    onclick={() => open = true}
    class={cn(
      "fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full shadow-lg px-4 py-3 cursor-pointer transition-all duration-200",
      "bg-primary-600 text-white hover:bg-primary-700 hover:shadow-xl",
      "text-sm font-medium",
    )}
    aria-label={hasExisting ? "Edit feedback" : "Give feedback"}
  >
    <MessageCircle size={18} strokeWidth={1.5} />
    <span class="hidden sm:inline">{hasExisting ? "Edit feedback" : "Feedback"}</span>
  </button>

  <FeedbackForm {feedback} bind:open {record} onSuccess={() => open = false} />
{/if}
